import type { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'

import type { FormValues } from '../providers/SingleSeriesProvider/types'

type CreateSingleSeriesPayload = Parameters<
  typeof MembershipsCreatorV2ApiClient.createSingleSeries
>[0]

export const getCreateSingleSeriesPayload = (values: FormValues): CreateSingleSeriesPayload => {
  return {
    title: values.title,
    postsType: 'video',
    description: values.description || '',
    coverImageResourceId: values.coverImageResourceId,
    thumbnailResourceId: values.thumbnailImageResourceId,
  }
}
